"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.toInterviewSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toInterviewSlice = function (data, logger) {
    var _a, _b, _c;
    var currentQuestionNumber = 0;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Interview)), { anchorName: logger.required(fields_1.toAnchor((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.anchorName)), title: logger.required(fields_1.toRichText((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.title, logger)), intro: logger.required(fields_1.toRichText((_c = data === null || data === void 0 ? void 0 : data.primary) === null || _c === void 0 ? void 0 : _c.intro, logger)), interviewees: __spreadArray([], Array(5)).reduce(function (acc, value, index) {
            var name = fields_1.toText(data === null || data === void 0 ? void 0 : data.primary["interviewee_" + (index + 1) + "_name"]);
            var role = fields_1.toText(data === null || data === void 0 ? void 0 : data.primary["interviewee_" + (index + 1) + "_role"]);
            if (name && role) {
                return __spreadArray(__spreadArray([], acc), [
                    {
                        name: name,
                        role: role,
                        avatar: fields_1.toImage(data === null || data === void 0 ? void 0 : data.primary["interviewee_" + (index + 1) + "_avatar"], logger)
                    },
                ]);
            }
            return acc;
        }, []), interview: data === null || data === void 0 ? void 0 : data.items.map(function (item) {
            var question = fields_1.toRichText(item.question, logger);
            if (!utils_1.isVoid(question)) {
                currentQuestionNumber++;
            }
            return utils_1.compact({
                questionNumber: currentQuestionNumber,
                question: question,
                answer: logger.required(fields_1.toRichText(item.answer, logger)),
                name: logger.required(fields_1.toText(item.name))
            });
        }) }));
};
exports.toInterviewSlice = toInterviewSlice;
//# sourceMappingURL=interview-slice.js.map